import BrandsNavigator from 'brandComponents/Brands/Subcomponents/BrandsNavigator';
import BreadCrumbs from 'brandComponents/Breadcrumbs';
import ChangeCountry from 'brandComponents/ChangeCountry';
import Footer from 'brandComponents/Footer';
import InTheMoodForBanner from 'brandComponents/InTheMoodFor/InTheMoodForBanner';
import NewsletterForm from 'brandComponents/NewsletterForm/NewsletterForm';
import NewsletterPopupForm from 'brandComponents/CMSPopup/Subcomponents/Newsletter/NewsletterPopupForm';
import PreorderPopupButton from 'brandComponents/product/PreorderPopupButton';
import PreorderShipmentDate from 'brandComponents/product/PreorderShipmentDate';
import ProductListFiltersControl from 'brandComponents/ProductListFilterControl/ProductListFiltersControl';
import ProductListGridContainer from 'brandComponents/ProductListGridContainer';
import ProductListHeading from 'brandComponents/ProductListHeading';
import ProductSearchCategories from 'brandComponents/ProductSearchCategories';
import SearchPageNoResults from 'brandComponents/SearchPageNoResults';
import TotalProducts from 'brandComponents/TotalProducts';

import Container from './subComponents/Container';
import {NavigationItemLinkImage} from '../NavigationItem/Subcomponents';

export const componentsMap = {
	BrandsNavigator: BrandsNavigator,
	BreadCrumbs: BreadCrumbs,
	ChangeCountry: ChangeCountry,
	Container: Container,
	'Footer.Copyright': Footer.Copyright,
	'Footer.MobileApp': Footer.MobileApp,
	'Footer.Newsletter': Footer.Newsletter,
	'Footer.Selectors': Footer.Selectors,
	InTheMoodForBanner: InTheMoodForBanner,
	NavigationItemLinkImage: NavigationItemLinkImage,
	NewsletterForm: NewsletterForm,
	NewsletterPopupForm: NewsletterPopupForm,
	PreorderPopupButton: PreorderPopupButton,
	PreorderShipmentDate: PreorderShipmentDate,
	ProductListFiltersControl: ProductListFiltersControl,
	ProductListGridContainer: ProductListGridContainer,
	ProductListHeading: ProductListHeading,
	ProductSearchCategories: ProductSearchCategories,
	SearchPageNoResults: SearchPageNoResults,
	TotalProducts: TotalProducts,
};
